import { useMemo } from 'react';
import { DropdownOption } from 'src/types/dropdown.types';
import { QuestionProps, Answer } from 'src/types/questionnaire.types';
import Dropdown from '../../../../components/kit/dropdown/Dropdown';
import Text from '../../../../components/kit/text/Text';

export const OptionSelectionQuestion = ({
  question,
  handleSelectAnswer,
  stepNumber,
  selectedOption = [],
}: QuestionProps) => {
  const onSelect = (answer: DropdownOption) => {
    handleSelectAnswer(
      {
        ...question,
        selections: [{ id: String(answer.key), title: answer.value }],
      },
      stepNumber
    );
  };
  const selected = useMemo(() => {
    const option = (selectedOption as Answer[])[0];
    return option ? { key: option.id, value: option.title } : null;
  }, [selectedOption]);

  return (
    <div className='pb-[12px]'>
      <Text weight='bold' style={{ paddingTop: '20px', paddingBottom: '12px' }}>
        Doctor type
      </Text>
      <Dropdown
        label='Select doctor type'
        placeholder='Select doctor type'
        value={selected}
        onChange={onSelect}
        options={
          question.selections
            ? question.selections.map((selection) => ({
                key: selection.id,
                value: selection.title,
              }))
            : []
        }
      />
    </div>
  );
};
